import { GlobalErrorHandler } from "Components/Error/GlobalErrorHandler";
import { Layout } from "Components/Layout/Layout";
import i18n from "i18next";
import * as React from "react";
import { ReactNode } from "react";
import { initReactI18next } from "react-i18next";
import { Provider, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import { Routes } from "Routes/Routes";
import { refreshAccessRightsAsync } from "State/Auth/AuthReducer";
import { useApplicationStore } from "State/Store";
import { CzechResourcesDictionary } from "Translations/CzechResourcesDictionary";
import "./Assets/css/ibis-shared.css";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      cs: CzechResourcesDictionary,
    },
    lng: "cs",
    fallbackLng: "cs",

    interpolation: {
      escapeValue: false,
    },
  });

function App() {
  const appStore = useApplicationStore();

  return (
    <Provider store={appStore.store}>
      <PersistGate loading={null} persistor={appStore.persistor}>
        <GlobalErrorHandler>
          <Layout>
            <AppStartup>
              <Routes />
            </AppStartup>
          </Layout>
        </GlobalErrorHandler>
      </PersistGate>
    </Provider>
  );
}

type AppStartupProps = { children?: ReactNode };

const AppStartup: React.FunctionComponent<AppStartupProps> = props => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(refreshAccessRightsAsync.request());
    // eslint-disable-next-line
  }, []);

  return <>{props.children}</>;
};

export default App;
